import React from "react";
import {
	View,
} from "react-native";

import StyledText from "ae-base/Base/StyledText";

import { useResources } from "@aetonix/hooks";

export default function ErrorMessage(props){
	const { localize } = useResources();
	const errors = props.errors;
	const schema = props.schema;

	if(!errors || !errors.length) return null;

	const messages = errors.map(function(error){
		const message = error.message;
		let localized = localize("formerrors." + message, schema) || localize(message) || localize("formerrors.unknown", error);
		if(message === "has less length than allowed" && schema.minLength === 1){
			localized = localize("formerrors.is required");
		} else if (message.indexOf("macaddress format") !== -1 && schema.format === "macaddress") {
			localized = localize("devices.macaddress");
		} else if (message === "must be email format" && schema.format === "email") {
			localized = localize("formerrors.email_format");
		}

		return  (
			<View key={message}>
				<StyledText id={props.id || false} alert>{localized}</StyledText>
			</View>
		);
	});

	return (
		<View>
			{messages}
		</View>
	);
}